export const CopyCustomFieldAsPublicApi = Symbol('CopyCustomFieldAsPublicApi');
